import {
  GET_PAYMENTS,
  GET_ACTIVITY_PAYMENTS,
  GET_EVENT_PAYMENTS,
  GET_USER_PAYMENTS,
  RESET_ACTIVITY_PAYMENTS_DETAILS,
  RESET_EVENT_PAYMENTS_DETAILS,
  RESET_USER_PAYMENTS_DETAILS,
  GET_EVENT_PARTICIPANTS_PAYMENT_DETAILS
} from '../actionTypes';

const initialState = {
  payments: [],
  activityPaymentDetails: null,
  eventPaymentDetails: null,
  userPaymentDetails: null,
  eventUserList:[]
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENTS:
      return {
        ...state,
        payments: action.payload,
      };
    case GET_ACTIVITY_PAYMENTS:
      return {
        ...state,
        activityPaymentDetails: action.payload,
      };
    case GET_EVENT_PAYMENTS:
      return {
        ...state,
        eventPaymentDetails: action.payload,
      };
    case GET_USER_PAYMENTS:
      return {
        ...state,
        userPaymentDetails: action.payload,
      };
    case RESET_ACTIVITY_PAYMENTS_DETAILS:
      return {
        ...state,
        activityPaymentDetails: null,
      };
    case RESET_EVENT_PAYMENTS_DETAILS:
      return {
        ...state,
        eventPaymentDetails: null,
      };
    case RESET_USER_PAYMENTS_DETAILS:
      return {
        ...state,
        userPaymentDetails: null,
      };
      case GET_EVENT_PARTICIPANTS_PAYMENT_DETAILS:
        return {
          ...state,
          eventUserDetails: null
        };
    default: {
      return state;
    }
  }
};

export default paymentReducer;
